import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import StateServices from "services/StateServices";
import { notifyError, notifySuccess } from "utils/toast";

const useStateSubmit = (id) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);

      const StateData = {
        country_name: data.country_name,
        name:data.name,
       
      };

      if (id) {
        const res = await StateServices.updateState(id, StateData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await StateServices.addState({ StateData });
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getStateData = async () => {
    try {
      const res = await StateServices.getStateByIdOne(id);
    
      if (res) {
        setValue("country_name", res.country_name);
        setValue("name",res.name);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("country_name");
      setValue("name");
      clearErrors("country_name");
      clearErrors("name");
      return;
    }
      
    if (id) {
      getStateData();
    }
    // eslint-disable-next-line
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    loading,
    setLoading,
    errors,
    isSubmitting,
  };
};

export default useStateSubmit;
